import * as actionTypes from '../constants/actionTypes';

/**
 * function for user get role reducer
 * @param {object} action action response
 * @param {function} getRoleReducer get role reducer function
 */
 export const getRoleReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.GET_ROLE_REQUEST:
            return {
                loading: true
            }
        case actionTypes.GET_ROLE_SUCCESS:
            return {
                loading: false,
                roles: action.payload.data
            }
  
        case actionTypes.GET_ROLE_FAIL:
            return {
                loading: false,
                error: action.payload
            }
  
        default: return state
    }
  }